import { Record } from 'immutable';

import { MapListEntity } from '../components/map-list/map-list.entity';

export const MapSliceKey = 'main';

export interface IMapMainSliceState {
	loading: boolean;
	list: MapListEntity;
	includePublicProjects: boolean;
	deleteSuccess: boolean;
}

export const defaults: IMapMainSliceState = {
	loading: false,
	list: MapListEntity.build([]),
	includePublicProjects: false,
	deleteSuccess: false,
};

export class MapMainSliceState extends Record<IMapMainSliceState>(defaults) {
	public static readonly key = MapSliceKey;

	public setLoading(isLoading: boolean): MapMainSliceState {
		return this.set('loading', isLoading);
	}

	public setMapList(mapList: MapListEntity): MapMainSliceState {
		return this.set('list', mapList);
	}

	public setDeleteSuccess(isSuccess: boolean): MapMainSliceState {
		return this.set('deleteSuccess', isSuccess);
	}

	public toggleIncludePublicProjects(
		includePublicProjects: boolean
	): MapMainSliceState {
		return this.set('includePublicProjects', includePublicProjects);
	}
}
